import React from 'react';

import IMG_HAIR_BEAUTY from 'assets/images/websites-portfolio/hair-and-beauty.png';
import IMG_LOUBELLAI from 'assets/images/websites-portfolio/loubellai.png';
import IMG_OSULLIVANS from 'assets/images/websites-portfolio/o-sullivan.png';
import IMG_SOPHISTICUTS from 'assets/images/websites-portfolio/sophisticutz.png';
import IMG_TRIMMERS from 'assets/images/websites-portfolio/trimmers.png';
import IMG_ZIG_ZAG from 'assets/images/websites-portfolio/zig-zag.png';
import ExternalLink from 'components/generic/ExternalLink.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import C from 'utils/values/constant.util';

import CN from './Showcase.module.scss';

const DATA = C([
  {
    id: 1,
    title: '“Superb service and guidance from start to finish”',
    subtitle: 'Martin O’Sullivan | Owner, O’Sullivans Bankside',
    image: IMG_OSULLIVANS,
    link: 'https://osullivanconceptsalons.getslick.com/',
  },
  {
    id: 2,
    title: '“Team Slick are exactly as they sound”',
    subtitle: 'Helen Hobson | Owner and Director, Sophisticutz',
    image: IMG_SOPHISTICUTS,
    link: 'https://sophisticutz.getslick.com/',
  },
  {
    id: 3,
    title: '“I wouldn’t dream of using anyone else!”',
    subtitle: 'Richard Smart | Principal Stylist, Zig Zag Salon',
    image: IMG_ZIG_ZAG,
    link: 'https://zigzagsalon.getslick.com/',
  },
  {
    id: 4,
    title: '“Amazing service and quality is outstanding”',
    subtitle: 'Karen Dobbs | Owner, Hair and Beauty Principles',
    image: IMG_HAIR_BEAUTY,
    link: 'https://hairandbeautyprinciples.getslick.com/',
  },
  {
    id: 5,
    title: '“We love it. Would definitely recommend”',
    subtitle: 'Holly Steele | Creative Director, Loubellai',
    image: IMG_LOUBELLAI,
    link: 'https://loubellaigreatharwood.getslick.com/',
  },
  {
    id: 6,
    title: '“Carla made it so easy! I’m such a technophobe”',
    subtitle: 'Darryl | Owner, Trimmers',
    image: IMG_TRIMMERS,
    link: 'https://trimmers.getslick.com/',
  },
]);

const Showcase = ({ tag }) => (
  <div className={CN.component} data-bem="Showcase" data-tag={fromAnyToTrimmed(tag)}>
    {DATA.map((item) => (
      <div className={CN.showcaseCard} key={item.id}>
        <ExternalLink link={item.link} variant="web">
          <div className={CN.imageContainer}>
            <img src={item.image} alt={item.title} />
          </div>
          <div className={CN.textContainer}>
            <div className={CN.title}>{item.title} </div>
            <div className={CN.subTitle}>{item.subtitle} </div>
          </div>
        </ExternalLink>
      </div>
    ))}
  </div>
);

export default Showcase;
